import { Button } from "@fullscreendigital/carrefour-dex-fe";
import { useQuery } from "react-query";
import { makeCoreGetRequest } from "utils/api";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { useNotification } from "hooks";
import { formatErrorMessage } from "utils/formatting";
import { useLocation, useNavigate } from "react-router-dom";
import { URLS } from "components/shop-reception/mobile/constants";
import { useState } from "react";
import { FormInfoItems } from "components/core-ui/FormInfoItems";
import AlertModal from "components/shop-reception/mobile/Common/AlertModal/AlertModal";

const ExpectedTrucksStep5 = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { showNotification } = useNotification()
  const [isAlertOpen, setIsAlertOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFinalizeModalOpen, setIsFinalizeModalOpen] = useState(false)
  const [finalizeModalContent, setFinalizeModalContent] = useState({ title: '', buttons: [] })

  const truckId = location.state.truckId

  const { data: hubName, isLoading: isLoadingHubName } = useQuery(
    ['hub-name'],
    async () => {
      const response = await makeCoreGetRequest(`/shop-reception-mobile/home/hub-name`)
      return response || []
    },
    {
      onError: error => {
        showNotification({
          message: `A aparut o eroare. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { data: manualCreated, isLoading: isLoadingManualCreatedInfo } = useQuery(
    ['manual-created', truckId],
    async () => {
      return await makeCoreGetRequest(`/shop-reception-mobile/truck/shop/manual-created-info/${truckId}`)
    },
    {
      onError: error => {
        showNotification({
          message: `A aparut o eroare. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { data: summary, isLoading: isSummaryLoading } = useQuery(
    ['summary', truckId],
    async () => {
      return await makeCoreGetRequest(`/shop-reception-mobile/support/hub/summary/${truckId}`)
    },
    {
      onError: error => {
        showNotification({
          message: `A aparut o eroare. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { data: counter, isLoading: isCounterLoading } = useQuery(
    ['counter', truckId],
    async () => {
      return await makeCoreGetRequest(`/shop-reception-mobile/support/hub/counter/${truckId}`)
    },
    {
      onError: error => {
        showNotification({
          message: `A aparut o eroare. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const finalizeTruck = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await makeCoreGetRequest(`/shop-reception-mobile/support/hub/finalise/${truckId}`)

      navigate("/goodsReceptionHub");
    } catch (e) {
      showNotification({
        message: `A aparut o eroare. ${formatErrorMessage(e)}`,
        type: 'error'
      })
    } finally {
      setIsSubmitting(false);
    }
  }

  const finaliseManualCreatedTruck = () => {
    setFinalizeModalContent({
      title: 'Confirmaţi finalizarea recepţiei camionului?',
      buttons: [
        {
          label: 'DA',
          onClick: () => {
            finalizeTruck()
            setIsFinalizeModalOpen(false);
          },
          color: 'primary',
          disabled: isSubmitting
        },
        {
          label: 'NU',
          onClick: () => setIsFinalizeModalOpen(false),
          color: 'secondary',
          disabled: isSubmitting
        }
      ]
    })
    setIsFinalizeModalOpen(true)
  }

  const closeFinalizeModal = () => {
    setIsFinalizeModalOpen(false)
  }

  if (isLoadingHubName || isSummaryLoading || isCounterLoading || isLoadingManualCreatedInfo) {
    return (
      <div style={{ display: 'flex' }}>
        <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
      </div>
    )
  }

  return (
    <Grid container spacing={2} justifyContent={'center'}>
      <Grid xs={12} item>
        <Typography
          component="h2"
          variant="medium"
          style={{ textAlign: 'center', textTransform: 'uppercase' }}
          pt={2}
        >
          {hubName.value}
        </Typography>
      </Grid>

      { !manualCreated &&
        <Grid xs={10} item>
          <Button
            variant="contained"
            label="Camion gol"
            onClick={() => setIsAlertOpen(true)}
            style={{ width: '100%' }}
          />
        </Grid>
      }
      { !manualCreated &&
        <Grid xs={10} item>
          <Button
            variant="contained"
            label="Resigileaza camion"
            onClick={() => navigate(URLS.AUTH_EXPECTED_TRUCKS_STEP6, { state: { truckId: truckId } })}
            style={{ width: '100%' }}
          />
        </Grid>
      }

      { manualCreated &&
        <Grid xs={10} item>
          <Button
            variant="contained"
            label="Finalizează camion"
            onClick={() => finaliseManualCreatedTruck()}
            style={{ width: '100%' }}
          />
        </Grid>
      }

      <Grid xs={10} item>
        <FormInfoItems
          items={[
            { label: 'Numar camion:', name: counter?.truckNumber },
            { label: 'Numar suporti scanati:', name: summary?.counter }
          ]}
        />
      </Grid>
      <AlertModal
        open={isAlertOpen}
        handleClose={() => setIsAlertOpen(false)}
        title={'Atentie'}
        description={`Camionul nu mai contine suporti de descarcat in nici o alta destinatie! Confirmati: `}
        buttons={[
          { label: 'Nu', onClick: () => setIsAlertOpen(false), color: 'primary' },
          {
            label: 'Da',
            onClick: () => finalizeTruck(),
            color: 'primary'
          }
        ]}
      />
      <AlertModal
        open={isFinalizeModalOpen}
        handleClose={closeFinalizeModal}
        title={finalizeModalContent.title}
        buttons={finalizeModalContent.buttons}
      />
    </Grid>
  )
}

export default ExpectedTrucksStep5
